/**
 * The one thing about a new password this console can decide for itself.
 *
 * Only the confirmation, and deliberately only that: the server is never told the second field, so
 * it could not check it however much it wanted to. Everything else - the length, the variety, whether
 * the new password repeats the old one - is `PasswordHashing.Problems` answering, and its message is
 * repeated here verbatim.
 *
 * Adding a length check here would feel helpful and would be the start of two rule sets that drift.
 * The server's rules are the product's rules; this is the only gap it cannot see into.
 */
export function localProblem(newPassword: string, confirmation: string): string | null {
  return newPassword === confirmation ? null : 'The two new passwords do not match.'
}
